/* eslint camelcase: 0 */
import { toUserProps } from './user'
import { toFileProps } from './file'
import { Message } from '@/infrastructure/network/Monitaro/schema/models'
import { IMessageProps, EmptyMessagePropsFactory } from '@/entities/Message'

export const toMessageProps = (props: Message | null | undefined): IMessageProps => {
  if (!props) {
    return EmptyMessagePropsFactory()
  }

  const { id, hospital_id, hospital, reads_count, from, title, content, users, industries, properties, type, files, sent_at, created_at, updated_at } = props

  return EmptyMessagePropsFactory({
    id,
    hospitalId: hospital_id ?? undefined,
    hospital,
    readsCount: reads_count,
    from,
    title,
    content,
    users: users?.map(toUserProps) || [],
    industries,
    properties,
    type,
    files: files?.map(toFileProps) || [],
    sentAt: sent_at,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
